import { StatusBadge } from '../status-badge';
import { statusTypeBadgeVariants } from './constants';

export const StatusCellRenderer = ({ status }: { status: string }) => {
  const variant = statusTypeBadgeVariants[status] ?? 'request-unknown';
  return <StatusBadge variant={variant} />;
};
